import { cx } from '@linaria/core';
import { infoMessage } from './InfoMessage.styles';
import { InfoMessageProps } from './types';

export const InfoMessage = ({ className, children }: InfoMessageProps) => <div className={cx(infoMessage, className)}>{children}</div>;
